<template>
    <div>
        <vapp-header btnBack></vapp-header>
            <div class="container">
                <form class="form-fnc" autocomplete="off" @submit.prevent="submitInvoiceDialog">
                        <div class="row section-border" @click="navigateSelectMethod">
                            <div class="col-12">
                                <b>Payment Method</b>
                                <p v-if="payment">{{payment.method_name}}</p>
                            </div> 
                        </div>
                    <div class="row section-border" @click="navigateSelectAccount">
                        <div class="col-12">
                            <b>Deposit To</b>
                            <p v-if="payment">{{payment.account_name}}</p>
                        </div>
                    </div>
                    <div class="col-12">
                        <label>Amount</label>
                        <input type="number" class="form-control padding-override" placeholder="Amount" v-model="paymentAmount">
                    </div>
                </form>
                <div style="padding-top: 10px"></div>
                <div class="col">
                    <button class="btn btn-block btn-fnc" @click="pushPayment()">Add this Payment</button>
                </div>
            </div>
        </div>
</template>

<script>
    import * as $$ from "lodash";
    import { mapState, mapActions } from 'vuex'
    import listSvc from '../../services/listService'
import { unlink } from 'fs';
    

    export default {
        name: "SelectPaymentMethod",
        data: () => ({

        }),
        computed: {
            ...mapState('invoice',['createInvoiceObj', 'editInvoiceObj', 'payments', 'currentPaymentLine', 'paymentAmount', 'isEditingInvoice']),
            payment () {
                let paymentData = {};
                if (this.isEditingInvoice){
                    paymentData = this.editInvoiceObj.partials[this.currentPaymentLine - 1];
                } else {
                    if (this.createInvoiceObj.partials != undefined) {
                        paymentData = this.createInvoiceObj.partials[this.currentPaymentLine - 1];
                    } else {
                        this.createInvoiceObj.partials = [];
                        paymentData = this.createInvoiceObj.partials[this.currentPaymentLine - 1];

                    }
                }
                return paymentData;
                // return this.createInvoiceObj.partials[this.currentPaymentLine - 1];
            },
        },
        methods: {
            ...mapActions('invoice', ['setCreateInvoiceObj', 'setEditInvoicePartial']),
            pushPayment() {
                let partialToPush = {
                    index : this.currentPaymentLine - 1,
                    partial : {
                        amount: this.paymentAmount
                    }
                };

                if (!this.isEditingInvoice){
                    this.setCreateInvoiceObj({ partials: partialToPush })
                } else {
                    this.setEditInvoicePartial(partialToPush)
                }
                this.$router.go(-1);
            },
            navigateSelectMethod () {
                this.$router.push({ name: 'select_method'});
            },
            navigateSelectAccount () {
                this.$router.push({ name: 'select_account'});
            },
        },
        mounted () {
            console.log("Mounted : Select Payment Method");
        }
    }
</script>

<style scoped>
    .section-border {
        border-bottom: 10px solid rgba(68, 43, 43, 0.1);
        height: 100px;
    }
    .col-12 {
        padding-top: 10px;
    }

</style>
